import type { DemoOwnerKey } from '@oche/shared';

const STORAGE_KEY = 'oche-api-key';

let token: string | null = null;
let ownerId: string | null = null;
let apiKey: DemoOwnerKey = readStoredKey();

function readStoredKey(): DemoOwnerKey {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'demo-key-a' || stored === 'demo-key-b') return stored;
  } catch {
    /* SSR / privacy mode */
  }
  return 'demo-key-a';
}

export function getApiKey(): string {
  return apiKey;
}

export function getToken(): string | null {
  return token;
}

export function getOwnerId(): string | null {
  return ownerId;
}

export function setAuthSession(next: { token: string | null; ownerId: string; apiKey: string }) {
  token = next.token;
  ownerId = next.ownerId;
  apiKey = next.apiKey as DemoOwnerKey;
  try {
    localStorage.setItem(STORAGE_KEY, apiKey);
  } catch {
    /* ignore */
  }
}

export function clearAuthSession() {
  token = null;
  ownerId = null;
}

export function getAuthHeaders(): Record<string, string> {
  if (token) return { Authorization: `Bearer ${token}` };
  return { 'x-oche-owner': apiKey };
}

export const DEMO_VENUES: Array<{ key: DemoOwnerKey; label: string }> = [
  { key: 'demo-key-a', label: 'Venue A' },
  { key: 'demo-key-b', label: 'Venue B' },
];
